import { Button, Skeleton } from '@affine/component';
import {
  WorkspaceTeamService,
} from '@affine/core/modules/permissions';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback, useEffect, useState } from 'react';
import { Virtuoso } from 'react-virtuoso';

import { MemberItem } from './member-item';
import * as styles from './member-management.css';
import { Scroller } from '@affine/core/modules/share-menu/view/share-menu/scroller';
import { OrganizeService } from '@affine/core/modules/organize';
import type { FolderRole } from '@affine/core/modules/db/schema/schema';
import { MembersPermission } from './members-permission';

export interface TeamOrUser {
  id: string;
  name: string;
  avatar?: string;
  type: 'user' | 'team';
  role: FolderRole;
}

export const MemberManagement = ({
  onClickBack,
  onClickInvite,
  nodeId
}: {
  onClickBack: () => void;
  onClickInvite: () => void;
  nodeId: string;
}) => {

  const workspaceTeamService = useService(WorkspaceTeamService);
  const organizeService = useService(OrganizeService);

  const [memberList, setMemberList] = useState<TeamOrUser[]>([]);

  const node = useLiveData(
    organizeService.folderTree.folderNode$(nodeId)
  );

  

  if (!node) {
    return null;
  }

  const permissions = useLiveData(node.permissions$);

  useEffect(() => {
    if (!permissions?.permissions?.length || permissions?.permissions?.length === 0) {
      setMemberList([]);
      return;
    }

    if (workspaceTeamService) {
      const ids = permissions?.permissions.map(permission => {
        return {
          id: permission.id,
          type: permission.type,
        }
      })
      workspaceTeamService.loadTeamOrUser(ids).then(res => {
        console.info('res', res);


        setMemberList(res.map(item => {
          const role = permissions?.permissions.find(permission => permission.id === item.id)?.role!;

          return {
            id: item.id,
            name: item.name,
            avatar: item.avatar,
            type: item.type as any,
            role: role,
          }
        }));

      })
    }

  }, [permissions, workspaceTeamService])


  const t = useI18n();


  const loadMore = useCallback(() => {
    // docGrantedUsersService.loadMore();
  }, []);

  return (
    <div className={styles.containerStyle}>
      <div className={styles.headerStyle}>
        <MembersPermission nodeId={nodeId} />
      </div>

      {memberList ? (
        <MemberList
          grantedUserList={memberList}
          loadMore={loadMore}
          canManageUsers={true}
          nodeId={nodeId}
        />
      ) : (
        <Skeleton className={styles.scrollableRootStyle} />
      )}
      <div className={styles.footerStyle}>
        {true ? (
            <span
              className={styles.addCollaboratorsStyle}
              onClick={onClickInvite}
            >
              {t['com.affine.share-menu.member-management.add-collaborators']()}
            </span>
        ) : null}

        <div className={styles.buttonsContainer}>
          <Button className={styles.button} onClick={onClickBack}>
            关闭
          </Button>
          
        </div>
      </div>
    </div>
  );
};

const MemberList = ({
  grantedUserList,
  loadMore,
  canManageUsers,
  nodeId
}: {
  canManageUsers: boolean;
  grantedUserList: TeamOrUser[];
  loadMore: () => void;
  nodeId: string
}) => {
  const itemContentRenderer = useCallback(
    (_index: number, data: TeamOrUser) => {
      console.info('rendering', data);
      return (
        <MemberItem
          key={data.id || data.id}
          grantedUser={data}
          canManageUsers={canManageUsers}
          nodeId={nodeId}
        />
      );
    },
    [canManageUsers]
  );
  return (
    <div className={styles.memberListStyle}>
      {grantedUserList.length < 8 ? (
        grantedUserList.map(item => (
          <MemberItem
            key={item?.id || item?.id}
            grantedUser={item}
            canManageUsers={canManageUsers}
            nodeId={nodeId}
          />
        ))
      ) : (
        <Virtuoso
          components={{
            Scroller,
          }}
          data={grantedUserList}
          itemContent={itemContentRenderer}
          // totalCount={grantedUserCount}
          endReached={loadMore}
        />
      )}
    </div>
  );
};
